import { IVideoListHeaderProps } from "interfaces";

const VideoListHeaderIcon = ({ className }: IVideoListHeaderProps) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                opacity="0.4"
                d="M7.81 2H16.19C16.25 2 16.31 2 16.36 2.01C16.9 2.01 17.4 2.07 17.86 2.18C20.02 2.65 21.42 4.09 21.85 6.28C21.95 6.75 22 7.25 22 7.78V16.28C21.99 16.81 21.94 17.31 21.84 17.78C21.4 19.93 20 21.35 17.86 21.82C17.4 21.93 16.9 21.99 16.36 21.99C16.31 22 16.25 22 16.19 22H7.81C7.3 22 6.81 21.96 6.36 21.87C4.1 21.45 2.62 20 2.16 17.78C2.05 17.31 2 16.81 2 16.28V7.77C2 7.24 2.05 6.74 2.15 6.28C2.59 4.02 4.08 2.55 6.36 2.13C6.81 2.04 7.3 2 7.81 2Z"
                fill="#14142A"
            />
            <path d="M7.86 11.25H16.36V2.01C16.9 2.01 17.4 2.07 17.86 2.18V6.28H21.85C21.95 6.75 22 7.25 22 7.78H17.86V11.25H22V12.75H17.86V16.28H22C21.99 16.81 21.94 17.31 21.84 17.78H17.86V21.82C17.4 21.93 16.9 21.99 16.36 21.99V12.75H7.86V22H7.81C7.3 22 6.81 21.96 6.36 21.87V17.76C6.32 17.77 6.28 17.78 6.24 17.78H2.16C2.05 17.31 2 16.81 2 16.28H6.24C6.28 16.28 6.32 16.3 6.36 16.31V12.75H2V11.25H6.36V7.78H2V7.77C2 7.24 2.05 6.74 2.15 6.28H6.33C6.34 6.28 6.35 6.29 6.36 6.29V2.13C6.81 2.04 7.3 2 7.81 2H7.86V11.25Z" />
        </svg>
    );
};

export default VideoListHeaderIcon;
